import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header-language',
  templateUrl: './header-language.component.html',
  styleUrls: ['./header-notification.component.scss'],
})
export class HeaderLanguageComponent implements OnInit {
  constructor(public translate: TranslateService) {}

  items!: MenuItem[];

  ngOnInit() {
    this.items = [
      {
        label: 'EN',
        command: () => {
          this.translate.use('en');
        },
      },
      {
        label: 'MY',
        command: () => {
          this.translate.use('my');
        },
      },
    ];
  }
}
